<template>
  <div id="users">
    <nav-bar :current-page="'USERS'" class="nav-bar" style="top: 0"></nav-bar>
    <user-list></user-list>
  </div>
</template>

<script>
import NavBar from '../components/NavBar.vue'
import UserList from '../components/UserList.vue'

export default {
  name: 'Users',
  components: { NavBar, UserList }
}
</script>

<style scoped>
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  transition: top 0.3s;
}
</style>
